$(document).ready(function () {
    const COOKIE_NAME = "cstm-sale-timer";
    const PST_OFFSET = 8 * 60 * 60000; // PST is UTC-8 hours

    function getPSTMidnight() {
      const now = new Date();
      const utcNow = now.getTime() + now.getTimezoneOffset() * 60000;
      const pstNow = new Date(utcNow - PST_OFFSET);
  
      // Set midnight PST (start of the next day)
      const pstMidnight = new Date(pstNow);
      pstMidnight.setUTCHours(8, 0, 0, 0); // 8 AM UTC == midnight PST
      pstMidnight.setUTCDate(pstMidnight.getUTCDate() + 1); // Always set for the next day
  
      return pstMidnight;
    }

    function getRemainingTime() {
        const now = new Date();
        const midnight = getPSTMidnight();
        const remaining = midnight - now; // Difference in milliseconds
        return {
            total: remaining,
            hours: Math.floor((remaining / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((remaining / (1000 * 60)) % 60),
            seconds: Math.floor((remaining / 1000) % 60)
        };
    }

    function setCookie(name, value, expires) {
        document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`;
    }

    function getCookie(name) {
        const cookies = document.cookie.split("; ");
        for (let i = 0; i < cookies.length; i++) {
            const [key, value] = cookies[i].split("=");
            if (key === name) return value;
        }
        return null;
    }

    function startTimer() {
        const timerElement = $("#cstm-sale-timer");
        const now = new Date();
        const midnight = getPSTMidnight();

        let initialRemaining = getRemainingTime().total;

        // Check if a cookie exists
        const savedTime = getCookie(COOKIE_NAME);
        if (savedTime) {
            const savedRemaining = parseInt(savedTime, 10);
            initialRemaining = Math.min(savedRemaining, initialRemaining);
        }

        // Save the initial remaining time in a cookie
        const cookieExpiry = new Date(midnight.getTime());
        setCookie(COOKIE_NAME, initialRemaining + now.getTime(), cookieExpiry);

        function updateTimer() {
            const remainingTime = getRemainingTime();
            if (remainingTime.total <= 0) {
                timerElement.text("00:00:00");
                return;
            }

            const hours = String(remainingTime.hours).padStart(2, "0");
            const minutes = String(remainingTime.minutes).padStart(2, "0");
            const seconds = String(remainingTime.seconds).padStart(2, "0");

            timerElement.text(`${hours}:${minutes}:${seconds}`);

            // Update the cookie with the latest time left
            const currentRemaining = remainingTime.total + new Date().getTime();
            setCookie(COOKIE_NAME, currentRemaining, cookieExpiry);
        }

        updateTimer();
        setInterval(updateTimer, 1000); // Update every second
    }

    startTimer();
});
